import type {
  ConstantMenuItem,
  MatchMenuItem,
  MenuItem,
  SportMenuItemNative,
  StageMenuItem,
  TournamentMenuItem,
  UnionMenuItem,
} from 'app/modules/Navigation/types';

// --

export enum PROMOTION_LEVEL {
  SPORT = 1,
  UNION = 2,
  TOURNAMENT = 3,
}

export type SportsMenuPromotedMenuItem = (
  UnionMenuItem |
  TournamentMenuItem |
  StageMenuItem
  );

export type UnionsMenuPromotedMenuItem = (
  TournamentMenuItem |
  StageMenuItem
  );

export type TournamentsMenuPromotedMenuItem = (
  StageMenuItem
  );

// --

export type RootMenuItem = (
  ConstantMenuItem |
  SportsMenuPromotedMenuItem |
  SportMenuItemNative
  );

export type UnionsMenuLayerItem = (
  UnionsMenuPromotedMenuItem |
  UnionMenuItem
  );

export type TournamentsMenuLayerItem = (
  TournamentsMenuPromotedMenuItem |
  TournamentMenuItem
  );

export type StagesMenuLayerItem = (
  StageMenuItem |
  MatchMenuItem
  );

export type FavoritesMenuLayerItem = (
  TournamentMenuItem |
  MatchMenuItem
  );

// --

export enum MENU_LAYER_TYPE {
  // CONSTANT = 'constant',
  UNIONS = 'unions',
  TOURNAMENTS = 'tournaments',
  SPORT_TOURNAMENTS = 'sport-tournaments',
  STAGES = 'stages',
  FAVORITES = 'favorites',
}

export interface MenuLayer {
  key: string;
  type: MENU_LAYER_TYPE;
  header: {
    title: string;
    location?: string;
  };
  visible: boolean;
  items: MenuItem[];
}

/* export interface ConstantMenuLayer extends MenuLayer {
  type: MENU_LAYER_TYPE.CONSTANT;
  layerId: string;
  items: ConstantMenuItem[];
} */

export interface UnionsMenuLayer extends MenuLayer {
  type: MENU_LAYER_TYPE.UNIONS;
  sportId: number;
  items: UnionsMenuLayerItem[];
}

export interface TournamentsMenuLayer extends MenuLayer {
  type: MENU_LAYER_TYPE.TOURNAMENTS;
  unionId: number;
  items: TournamentsMenuLayerItem[];
}

export interface SportTournamentsMenuLayer extends MenuLayer {
  type: MENU_LAYER_TYPE.SPORT_TOURNAMENTS;
  sportId: number;
  items: TournamentsMenuLayerItem[];
}

export interface StagesMenuLayer extends MenuLayer {
  type: MENU_LAYER_TYPE.STAGES;
  tournamentId: number;
  items: StagesMenuLayerItem[];
}

export interface FavoritesMenuLayer extends MenuLayer {
  type: MENU_LAYER_TYPE.FAVORITES;
  items: FavoritesMenuLayerItem[];
}

// --

export type FavoriteMatchesMenuState = {
  loading: boolean;
  items: MatchMenuItem[];
};

// --

export type MenuLayerLevel = '0' | '1' | '2' | '3';

// --

export type MatchObjectNumber = '1' | '2';
